import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { logout } from '../../actions/auth/auth'
import LostSession from '../../components/auth/LostSession'

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      logout
    }, dispatch)
  }
}

export default connect(null, mapDispatchToProps)(withTranslation()(LostSession))